import {
  Box,
  Button,
  CircularProgress,
  Typography,
  alpha,
} from "@mui/material";
import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import ScheduleIcon from "@mui/icons-material/Schedule";
import Image from "next/image";
import { FormatedTime } from "../genericComponents/formated-time/FormatedTime";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useCurrencyCode } from "../genericComponents/helper-functions/CurrencySymbol";
import { AddToCartService } from "@/app/services/cart";
import { SEARCH } from "./searchUi";

interface SearchServiceMobileCardProps {
  item: any;
  setReloadViewDetailsItem: any;
  updateCard: any;
  setUpdateCard: any;
  setOpenMaxService: any;
  handleOpenViewDetailsRsOne: any;
}

export const SearchServiceMobileCard: React.FC<SearchServiceMobileCardProps> = ({
  item,
  setReloadViewDetailsItem,
  updateCard,
  setUpdateCard,
  setOpenMaxService,
  handleOpenViewDetailsRsOne,
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [isClicked, setIsClicked] = React.useState(false);
  const [value, setVaue] = React.useState(1);
  const currencyCode = useCurrencyCode();
  const addToCartService = React.useMemo(() => new AddToCartService(), []);

  React.useEffect(() => {
    const jsonCount = addToCartService.checkIfAvailable(item?.id, item?.cid);
    if (jsonCount.count > 0) {
      setIsClicked(true);
      setVaue(jsonCount.count);
    } else {
      setIsClicked(false);
    }
    setUpdateCard(false);
  }, [updateCard, addToCartService, item?.id, item?.cid, setUpdateCard]);

  const handleClickButton = async (item: any, e: any) => {
    e.stopPropagation();
    setIsLoading(true);
    if (item?.addOn == true) {
      handleOpenViewDetailsRsOne(item);
      setIsLoading(false);
    } else {
      const countJson = await addToCartService.addToCart(
        item?.id,
        true,
        item?.cid,
        item?.coverImage?.secureHttpPath,
        item?.aboutList,
        item?.subHeading,
        item?.serviceCharge,
        item?.productCost,
        item?.min,
        item?.specialPrice,
        item?.specialMessage
      );
      if (countJson?.count && countJson?.count > 0) {
        setVaue(countJson.count);
        setIsClicked(true);
        setReloadViewDetailsItem(true);
        setIsLoading(false);
      } else {
        setIsClicked(false);
        setReloadViewDetailsItem(true);
        setIsLoading(false);
      }
    }
  };

  const handleValueDecrease = async (item: any, e: any) => {
    e.stopPropagation();
    setIsLoading(true);
    const countJson = await addToCartService.addToCart(
      item?.id,
      false,
      item?.cid,
      item?.coverImage?.secureHttpPath,
      item?.aboutList,
      item?.subHeading,
      item?.serviceCharge,
      item?.productCost,
      item?.min,
      item?.specialPrice,
      item?.specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      setReloadViewDetailsItem(true);
      setIsLoading(false);
    } else {
      setIsClicked(false);
      setReloadViewDetailsItem(true);
      setIsLoading(false);
    }
  };

  const handleValueIncrease = async (item: any, e: any) => {
    e.stopPropagation();
    setIsLoading(true);
    const countJson = await addToCartService.addToCart(
      item?.id,
      true,
      item?.cid,
      item?.coverImage?.secureHttpPath,
      item?.aboutList,
      item?.subHeading,
      item?.serviceCharge,
      item?.productCost,
      item?.min,
      item?.specialPrice,
      item?.specialMessage
    );
    if (countJson?.count && countJson?.count > 0) {
      setVaue(countJson.count);
      setIsClicked(true);
      setReloadViewDetailsItem(true);
      if (countJson?.count === 5) {
        setOpenMaxService(true);
      }
      setIsLoading(false);
    } else {
      setIsClicked(false);
      setReloadViewDetailsItem(true);
      setIsLoading(false);
    }
  };

  const imgSrc = item?.coverImage?.secureHttpPath;
  const aboutPreview = item?.aboutList?.slice(0, 4) ?? [];

  return (
    <Box
      component="article"
      sx={{
        p: { xs: 1.5, sm: 2 },
        bgcolor: SEARCH.surfaceElevated,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 1.5,
          alignItems: { sm: "flex-start" },
        }}
      >
        <Box
          sx={{
            position: "relative",
            flexShrink: 0,
            alignSelf: { xs: "center", sm: "flex-start" },
          }}
        >
          {item?.serviceTag && (
            <Typography
              component="span"
              sx={{
                position: "absolute",
                top: -6,
                left: -4,
                zIndex: 1,
                px: 0.75,
                py: 0.25,
                borderRadius: "6px",
                fontSize: "0.65rem",
                fontWeight: 800,
                textTransform: "uppercase",
                letterSpacing: "0.04em",
                background: `linear-gradient(135deg, ${SEARCH.accentGold} 0%, #e8d48a 100%)`,
                color: SEARCH.primaryDark,
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              {item?.serviceTag}
            </Typography>
          )}
          <Box
            sx={{
              position: "relative",
              width: { xs: 88, sm: 88 },
              height: { xs: 88, sm: 88 },
              borderRadius: SEARCH.radiusMd,
              overflow: "hidden",
              border: `1px solid ${SEARCH.border}`,
              bgcolor: alpha(SEARCH.primary, 0.04),
            }}
          >
            {imgSrc ? (
              <Image
                src={imgSrc}
                alt={item?.name ? `${item.name} — service` : "Service"}
                width={88}
                height={88}
                sizes="88px"
                unoptimized
                style={{
                  objectFit: "cover",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
              />
            ) : null}
          </Box>
        </Box>

        <Box sx={{ flex: 1, minWidth: 0, width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 1.25,
              alignItems: { sm: "flex-start" },
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ minWidth: 0, flex: 1 }}>
              <Typography
                sx={{
                  fontFamily: SEARCH.fontDisplay,
                  fontWeight: 700,
                  fontSize: { xs: "1.05rem", sm: "1.12rem" },
                  lineHeight: 1.25,
                  color: SEARCH.text,
                  letterSpacing: "-0.02em",
                }}
              >
                {item?.name}
              </Typography>
              {item?.subHeading ? (
                <Typography
                  sx={{
                    mt: 0.35,
                    fontSize: "0.8rem",
                    color: SEARCH.muted,
                    lineHeight: 1.45,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item?.subHeading}
                </Typography>
              ) : null}

              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "baseline",
                  gap: "6px 10px",
                  mt: 1,
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontSize: "1.05rem",
                    fontWeight: 800,
                    color: SEARCH.primary,
                  }}
                >
                  {currencyCode}
                  {item?.amount}
                </Typography>
                {item?.mrp != null && Number(item?.mrp) > Number(item?.amount) ? (
                  <Typography
                    component="span"
                    sx={{
                      fontSize: "0.85rem",
                      color: alpha(SEARCH.text, 0.38),
                      textDecoration: "line-through",
                    }}
                  >
                    {currencyCode}
                    {item?.mrp}
                  </Typography>
                ) : null}
                {item?.discount != null && item?.discount !== "" ? (
                  <Box
                    component="span"
                    sx={{
                      fontSize: "0.72rem",
                      fontWeight: 700,
                      px: 0.85,
                      py: 0.2,
                      borderRadius: "999px",
                      bgcolor: alpha(SEARCH.primary, 0.1),
                      color: SEARCH.primary,
                    }}
                  >
                    Save {currencyCode}
                    {item?.discount}
                  </Box>
                ) : null}
              </Box>

              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 0.75,
                  mt: 1,
                  px: 1,
                  py: 0.45,
                  borderRadius: "999px",
                  bgcolor: alpha(SEARCH.primary, 0.06),
                  border: `1px solid ${alpha(SEARCH.primary, 0.12)}`,
                }}
              >
                <ScheduleIcon
                  sx={{ fontSize: 16, color: SEARCH.primary, opacity: 0.85 }}
                />
                <Typography
                  sx={{
                    fontSize: "0.78rem",
                    fontWeight: 700,
                    color: SEARCH.primaryDark,
                  }}
                >
                  <FormatedTime min={item?.min} />
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                flexShrink: 0,
                display: "flex",
                justifyContent: { xs: "stretch", sm: "flex-end" },
                width: { xs: "100%", sm: "auto" },
                minWidth: { sm: 128 },
              }}
            >
              {isLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    minHeight: 40,
                    borderRadius: "999px",
                    border: `1px solid ${alpha(SEARCH.primary, 0.35)}`,
                    bgcolor: alpha(SEARCH.primary, 0.04),
                  }}
                >
                  <CircularProgress size={22} sx={{ color: SEARCH.primary }} />
                </Box>
              ) : isClicked ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    minHeight: 40,
                    px: 1,
                    borderRadius: "999px",
                    bgcolor: SEARCH.primary,
                    color: "#fff",
                    boxShadow: `0 4px 14px ${alpha(SEARCH.primary, 0.35)}`,
                  }}
                >
                  <RemoveIcon
                    onClick={(e) => handleValueDecrease(item, e)}
                    sx={{
                      cursor: "pointer",
                      p: 0.5,
                      borderRadius: "50%",
                      "&:hover": { bgcolor: alpha("#fff", 0.12) },
                    }}
                    aria-label="Decrease quantity"
                  />
                  <Typography sx={{ fontSize: "0.95rem", fontWeight: 800 }}>
                    {value}
                  </Typography>
                  <AddIcon
                    onClick={(e) => handleValueIncrease(item, e)}
                    sx={{
                      cursor: "pointer",
                      p: 0.5,
                      borderRadius: "50%",
                      "&:hover": { bgcolor: alpha("#fff", 0.12) },
                    }}
                    aria-label="Increase quantity"
                  />
                </Box>
              ) : (
                <Button
                  variant="contained"
                  disableElevation
                  fullWidth
                  onClick={(e) => handleClickButton(item, e)}
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: 800,
                    textTransform: "none",
                    minHeight: 40,
                    px: 2,
                    borderRadius: "999px",
                    bgcolor: SEARCH.primary,
                    boxShadow: `0 4px 14px ${alpha(SEARCH.primary, 0.28)}`,
                    "&:hover": {
                      bgcolor: SEARCH.primaryDark,
                      boxShadow: `0 6px 18px ${alpha(SEARCH.primary, 0.35)}`,
                    },
                  }}
                >
                  Add to cart
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      {aboutPreview.length > 0 ? (
        <Box
          sx={{
            pt: 1.25,
            mt: 0.25,
            borderTop: `1px solid ${alpha(SEARCH.primary, 0.08)}`,
            display: "flex",
            flexDirection: "column",
            gap: 0.65,
          }}
        >
          {aboutPreview.map((nestedItem: any, index: number) => {
            const parts = String(nestedItem).split("-");
            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 0.75,
                }}
              >
                <CheckIcon
                  sx={{
                    fontSize: 16,
                    color: SEARCH.primary,
                    mt: 0.15,
                    flexShrink: 0,
                  }}
                />
                <Typography
                  sx={{
                    fontSize: "0.78rem",
                    lineHeight: 1.45,
                    color: SEARCH.text,
                  }}
                >
                  {parts.length > 1 ? (
                    <>
                      <Box component="span" sx={{ fontWeight: 700 }}>
                        {parts[0].trim()} —{" "}
                      </Box>
                      {parts.slice(1).join("-").trim()}
                    </>
                  ) : (
                    nestedItem
                  )}
                </Typography>
              </Box>
            );
          })}
          {item?.aboutList?.length > 4 ? (
            <Typography sx={{ fontSize: "0.72rem", color: SEARCH.muted, pl: 2.5 }}>
              +{item.aboutList.length - 4} more — tap card for details
            </Typography>
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};
